export default __webpack_public_path__ + "static/media/login-people-illustration.438ff0a2.svg";